import React, { useState } from "react";
import {
  Checkbox,
  Col,
  Flex,
  Modal,
  Row,
  Switch,
  Typography,
} from "antd";
import { UsimTypeItem } from "../../../../api/usim/uploads/products/usimTypeItem";

const { Title, Text } = Typography;

interface ProductTypeModalProps {
  isVisible: boolean;
  onClose: () => void;
  productType: UsimTypeItem | null;
  onStatusChange: (productType: UsimTypeItem) => Promise<void>;
}

export default function ProductTypeModal({
  isVisible,
  onClose,
  productType,
  onStatusChange,
}: ProductTypeModalProps) {

  return (
    <Modal
      title="Product Type Details"
      open={isVisible}
      onCancel={onClose}
      width={600}
    >
      {productType && (
        <Flex gap={16} vertical>
          {/* Action Buttons */}
          <Flex justify="space-between" align="center">
            <Title level={4} style={{ margin: 0 }}>
              {productType.name}
            </Title>
            {/* create a toggle switch for the status */}
            <Switch checked={productType.status} onChange={() => onStatusChange(productType)} />
          
          </Flex>

          {/* Product Details */}
            <div>
              <Title level={5}>Product Details</Title>
              <Row gutter={16}>
                <Col span={12}>
                  <Text strong>Product Type:</Text>
                  <br />
                  <Text>{productType.name}</Text>
                </Col>
              </Row>
              <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={12}>
                  <Text strong>Has ICCID:</Text>
                  <br />
                  <Checkbox checked={productType.iccid} disabled />
                </Col>
             
              </Row>
             
            </div>
          
        </Flex>
      )}
    </Modal>
  );
}
